import React, { useContext } from "react";
import Box from "@mui/material/Box";
import { personnelDetailContext } from "../../PersonnelDetail";
import InterviewLink from "../molecules/InterviewLink";
import { NormalText } from "../../../../components/TextParts";

export default function SideBar() {
  const { personnelList = [], matchingIndex, offerList = [] } = useContext(
    personnelDetailContext
  );

  if (!personnelList[matchingIndex]) {
    return (
      <Box
        sx={{
          bgcolor: "#fff",
          p: "20px",
          borderRadius: "5px",
        }}
      />
    );
  }

  const hasOffer = offerList.length > 0 && offerList[0]?.registed_at !== "noOffer";

  return (
    <Box sx={{ marginTop: { xs: "15px", sm: "40px" } }}>
      {hasOffer ? (
        offerList.map((data, index) => (
          <Box
            key={data.id || index}
            sx={{
              bgcolor: "#fff",
              p: "20px",
              borderRadius: "5px",
              marginBottom: { xs: "10px", sm: "20px" },
            }}
          >
            <InterviewLink
              registedAt={data.registed_at}
              mailSubject={data.mail_subject}
              url={data.url_string}
              memo={data.memo}
              status={data.personnel_status_view_name}
              updateAt={data.update_at}
            />
          </Box>
        ))
      ) : (
        <Box
          sx={{ py: "20px", bgcolor: "#fff", p: "20px", borderRadius: "5px" }}
        >
          <NormalText text="打合せ予定はありません" />
        </Box>
      )}
    </Box>
  );
}